import VIEWPORTS from '../plugins/viewports'
import TAGMANAGER from '../plugins/tagmanager'
import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'
import ADOBEFONTS from '../plugins/adobefont';
import GOOG_TRANSLATE from '../plugins/googletranslate';

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'contentFooter': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
  }

  VIEWPORTS() // Viewportの置き換え
  TAGMANAGER() // GoogleTagManagerの挿入
  GOOG_TRANSLATE({ // GoogleTranslate
    GA_ID: 'UA-19412893-40',
    lang: 'ar,cy,da,de,el,en,es,fi,fr,gd,hr,id,is,it,ja,kk,ko,la,nl,pl,pt,ru,sk,sv,th,tl,tr,vi,zh-CN,zh-TW'
  })
  ADOBEFONTS(window.siteinfo.adobefonts) // ADOBE Fontsタグの挿入
  
  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html',
      target: 'footer #footerNav',
      method:'replaceWith'
    },
    {
      name: 'contentFooter',
      loadhtml: '/asset/html/contentFooter.html',
      target: 'footer,#footer.ui-footer',
      method:'before',
      callback(r,_){
        $('.homeContentslist').insertBefore('#footer');
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html',
      target: 'header',
      method:'replaceWith',
      callback(){
        // gmenu current
        $('.p-gnav').currentMenu({mode:1,default:999});
      }
    }
  ])
  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'class':'contImage',
    'sitemap':'サイトマップ',
    'privacy':'プライバシーポリシー',
    'profile':'会社概要'
  })

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'PREV',
      next:'NEXT',
      list:'LIST'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore() {
        $('.p-gotop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-gotop__wrap').removeClass('hidden');
      }
    })

    // SP .notranslate
    if( $.UA.is_mobile ){
      const replace_yaramaika = (i,obj) => {
        obj.innerHTML = obj.innerHTML.replace(/(やらまいか)/g,'<span class="notranslate">$1</span>')
      }
      // グローバルナビ
      $('.contentslist li a',"#header_menu").each(replace_yaramaika)

      // トップページコンテンツナビ
      $('.homeContentslist li a').each(replace_yaramaika)

      // 認定商品一覧
      $('ul.ui-listview li h4','.listContents').addClass('notranslate')
      $('ul.ui-listview li h4 + p','.listContents').addClass('notranslate')

    }
  })
  
  $(window).on('load',() => document.querySelector('body').classList.add('page-loaded') )

}